import React, { useState } from 'react';

const ProjectTimelineGenerator = () => {
  const [phases, setPhases] = useState([{ name: '', duration: '' }]);

  const handleInputChange = (index, event) => {
    const values = [...phases];
    values[index][event.target.name] = event.target.value;
    setPhases(values);
  };

  const addPhase = () => {
    setPhases([...phases, { name: '', duration: '' }]);
  };

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg mb-6">
      <h2 className="text-3xl font-bold mb-4">Generador de Cronogramas de Proyecto</h2>
      {phases.map((phase, index) => (
        <div key={index} className="flex mb-2">
          <input 
            type="text" 
            placeholder="Nombre de la fase" 
            name="name" 
            value={phase.name} 
            onChange={(e) => handleInputChange(index, e)} 
            className="w-1/2 p-2 border rounded" 
          />
          <input 
            type="number" 
            placeholder="Duración (días)" 
            name="duration" 
            value={phase.duration} 
            onChange={(e) => handleInputChange(index, e)} 
            className="w-1/2 p-2 border rounded ml-2" 
          />
        </div>
      ))}
      <button onClick={addPhase} className="px-4 py-2 bg-blue-500 text-white rounded mb-4">Añadir Fase</button>
      <div className="mt-4">
        <h3 className="text-xl font-bold mb-2">Cronograma del Proyecto:</h3>
        {phases.map((phase, index) => (
          <p key={index}>{phase.name} - {phase.duration} días</p>
        ))}
      </div>
    </div>
  );
};

export default ProjectTimelineGenerator;
